import { render, staticRenderFns } from "./ListTabs.vue?vue&type=template&id=23d53d7c&"
import script from "./ListTabs.vue?vue&type=script&lang=js&"
export * from "./ListTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItemGroup})
